import React, {FC} from 'react';

import {
  DropdownItem,
  DropdownItemProps,
} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemMultiline} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemMultiline';
import {buildContactDisplayHandle, buildContactDisplayName} from '../../../../helpers/models/contactHelpers';
import {VisualRecipientModel} from '../../../../models/api/visualRecipientModel';
import {DropdownItemContactAvatar} from '../dropdownItemContactAvatar';

/*
 * Props.
 */

interface RecipientDropdownItemProps extends DropdownItemProps {
  recipient: VisualRecipientModel;
}

/*
 * Component.
 */

export const RecipientDropdownItem: FC<RecipientDropdownItemProps> = (props) => {
  const {recipient} = props;

  // Build the display name and handle.
  const name = buildContactDisplayName(recipient);
  const handle = buildContactDisplayHandle(recipient);

  return (
    <DropdownItem {...props}>
      <DropdownItemContactAvatar contact={recipient} />
      <DropdownItemMultiline title={name} subtitle={handle} />
    </DropdownItem>
  );
};
